import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useHistory } from 'react-router-dom';

// Importações para Compliance
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';

//Table
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableFooter from '@material-ui/core/TableFooter';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../actions";

import { headerSearch, unoTheme } from '../../../assets/styles/unoTheme';
import {
    applyMaskAccount,
    applyMaskAmount,
    calcRentInSegregation,
    checkAssetsFormattedIsSegregated,
    getFirstAndEndDateByMonthAndYear,
    getMonthName,
    getTitleCod,
    isLastResolutionDate
} from "../../utils/utils";
// import NewAssetModal from "../../modals/NewAssetModal";

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';

import Tooltip from '@material-ui/core/Tooltip';


import { getAssetInfos } from '../../../controllers/AssetsController';
import { loadClientDiaryByRange, loadClientRentsBySegregation } from '../../../controllers/ClientController';

import Fab from '@material-ui/core/Fab';
import Zoom from '@material-ui/core/Zoom';
import PrintIcon from '@material-ui/icons/Print';

import { GENERIC_ASSETS } from "../../../controllers/TitleController";
import { codsInnerLoad } from '../../utils/MyInnerLoad';
import { disponibilizationDicionary } from "../../utils/dicionarys";

//Import excel
import XLSX from 'xlsx';
import { downloadBlob, s2ab } from "../../../controllers/ExcelController";
import { reportTypes } from "../../utils/ReportTypes";
import { getRegimeLabel } from "../../utils/accountRegimes";

import CloseIcon from '@material-ui/icons/Close';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import moment from 'moment';

// Importações para Compliance
import { LegislationArticleAPI } from '../../../API/legislation_article';
import { checkComplianceOutStatus, checkComplianceAlmostOutStatus, buildRulesComplianceIndex, checkRulesComplianceOutStatus, buildRulesOverview } from '../../utils/complianceUtils';
import { checkUserIsRole, roles } from '../../utils/user';
import { BalancesValidationsAPI } from '../../../API/balances_validations';

const rightDivWidth = 450;

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.black,
        color: 'white',
        //boxShadow: theme.shadows[1],
        fontSize: 11,
    },
    arrow: {
        color: theme.palette.common.black,
    },
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'row',
        height: '100%',
        width: '100%',
    },
    headerSearch: headerSearch,

    inputSearch: {
        width: "300px",
        background: "white"
    },
    tableContainer: {
        padding: '0px 18px 16px 18px',
        borderRadius: '10px 0px 0px 10px',
    },
    table: {
        tableLayout: 'fixed',
        '& .MuiTableRow-head': {
            '& .MuiTableCell-root': {
                backgroundColor: 'white',
                borderBottom: 'none',
                color: unoTheme.defaultTextColor,
                fontWeight: '500',
                textTransform: 'uppercase',
                fontSize: '12px',
                padding: '16px 24px 16px 16px',
            },
        },
    },
    clickableHead: {
        cursor: 'pointer',
    },
    accordionNewClient: {
        marginBottom: theme.spacing(2),
    },
    heading: {
        display: 'flex',
        alignItems: 'center'
    },
    labelHeading: {
        marginTop: '2px'
    },
    rootForm: {
        // '& .MuiTextField-root': {
        //     margin: theme.spacing(1),
        //     width: '25ch',
        // },
        textAlign: "left",
    },
    progressInput: {
        width: '20px !important',
        height: '20px !important',
    },
    myDatePicker: {
        marginTop: '-6px'
    },
    green: {
        color: unoTheme.greenMoney
    },

    leftChart: {
        padding: theme.spacing(2),
        width: '50%',
    },

    leftHeaderDetail: {
        display: "flex",
        alignItems: "baseline",
    },
    rightHeader: {
        display: 'flex',
        alignItems: 'center',
    },

    //RightDiv
    mainRoot: {
        height: '100%',
        width: '100%',
        transition: 'all .3s ease',
    },
    rightDiv: {
        height: '100%',
        minWidth: rightDivWidth,
        width: rightDivWidth,
        background: 'white',
        transition: 'all .3s ease',
        position: 'fixed',
        right: 0,
        //paddingRight: theme.spacing(2),
        marginRight: rightDivWidth * (-1),
    },
    rightDivOpen: {
        height: '100%',
        //marginRight: rightDivWidth - 24,
        marginRight: rightDivWidth,
        borderRight: `solid 24px ${unoTheme.menuContent}`,
    },
    rightDivClose: {
        height: '100%',
        marginRight: '0px',
    },
    rightDivContentOpen: {
        marginRight: '0px',

    },
    rightDivContentClose: {
        marginRight: rightDivWidth * (-1),
    },
    leftRightDiv: {
        background: unoTheme.menuContent,
        height: '100%',
        width: '24px',
        minWidth: '24px',
    },
    mainRightDiv: {
        float: 'right',
        height: '100%',
        //width: rightDivWidth - 24,
        //minWidth: rightDivWidth - 24,        
        width: rightDivWidth,
        minWidth: rightDivWidth,
    },
    openButton: {
        transition: 'all .3s ease',
    },
    rightDivButtonOpen: {
        opacity: 0,
        cursor: 'unset'
    },
    rightDivButtonClose: {
        opacity: 1,
        cursor: 'pointer',
    },
    headerRightDiv: {
        display: "flex",
        alignItems: 'center',
        padding: theme.spacing(2),

        '& .MuiTypography-root': {
            marginBottom: '0px',
        },

        '& .MuiIconButton-root': {
            padding: '8px',
        }
    },
    spacingLeft1: {
        marginLeft: theme.spacing(1)
    },
    spacingLeft2: {
        marginLeft: theme.spacing(2)
    },
    tableFixed: {
        tableLayout: 'fixed',
    },
    myTableFooter: {
        cursor: "pointer",
        borderBottom: 'unset',
        '& > *': {
            borderBottom: 'unset',
        },

        '& .totalLineInvestiments': {
            '& .MuiTableCell-root': {
                color: 'black',
                borderBottom: 'unset',
                background: unoTheme.mainGrayColor,
            },
        },

        '& .totalLinePL': {
            '& .MuiTableCell-root': {
                borderBottom: 'unset',
                color: 'white',
                background: unoTheme.mainColor,
            },
        },

        '& .disponibilityLine': {
            '& .MuiTableCell-footer': {
                color: 'black',
            },
        },

        '& .MuiTableCell-root:first-child': {
            borderTopLeftRadius: '10px',
            borderBottomLeftRadius: '10px',
        },

        '& .MuiTableCell-root:last-child': {
            borderTopRightRadius: '10px',
            borderBottomRightRadius: '10px',
        },

        '& .spanTotal': {
            //color: unoTheme.greenMoney,
            fontSize: '14px',
        }
    },

    tableWithFooter: {
        display: 'flex',
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'space-between'
    },

    footerTable: {
        color: 'white',
        margin: '0px 18px 18px 18px',
        borderRadius: '10px',
        minHeight: '32px',
        backgroundColor: unoTheme.mainColor,
        width: 'calc (100%-32px)',
        height: '32px',
        display: 'flex',
        alignItems: 'center',

        '& .MuiTypography-root': {
            fontSize: '12px',
        },

        '& .d': {
            padding: '16px',
        },
        '& .d1': {
            textAlign: 'left',
            width: "39%"
        },
        '& .d2': {
            width: "15%",
            textAlign: 'right',
        },
        // '& .d4': {
        //     width: "35%"
        // }
    },

    fabAdd: {
        position: 'absolute',
        backgroundColor: unoTheme.mainColor,
        right: theme.spacing(4),
        bottom: unoTheme.bottomFab,
        '&:hover': {
            background: unoTheme.hoverMainButtonColor,
        }
    },
    '@keyframes fadeIn': {
        '0%': {
            opacity: 0,
            transform: 'translateY(-4px)',
        },
        '100%': {
            opacity: 1,
            transform: 'translateY(0)',
        },
    },
}));


export default function AssetsScreen(props) {

    const { setCountBlankAprs, onComplianceLoaded } = props;

    const classes = useStyles();

    const dispatch = useDispatch();
    const history = useHistory();

    const clientOn = useSelector(state => state.clientOn)
    const currentUser = useSelector(state => state.currentUser)
    const [clientOnScreen, setClientOnScreen] = useState(undefined);

    const [appearFab, setAppearFab] = useState(true);

    const [resolutionName, setResolutionName] = useState(null);

    const [assetsFormatted, setAssetsFormatted] = React.useState([]);
    const [mapRentsBySegregation, setMapRentsBySegregation] = React.useState(null);
    const [totalResultAmount, setTotalResultAmount] = useState(0);
    const [totalRentPercentInMonth, setTotalRentPercentInMonth] = useState(0);
    const [totalRentMoneyInMonth, setTotalRentMoneyInMonth] = useState(0);
    const [totalDisponibilityInAccounts, setTotalDisponibilityInAccounts] = useState({
        now: 0,
        before: 0
    });

    const [rentMonthMode, setRentMonthMode] = useState('percent')

    //Charts
    const [dataChartParticipation, setDataChartParticipation] = useState(false);

    // Novos estados para controle de desenquadramentos
    const [complianceData, setComplianceData] = useState(null);

    //Identifica a última requisição de compliance disparada: trocar de mês rápido deixa mais de
    //uma em voo e a antiga não pode sobrescrever a nova ao resolver depois
    const complianceRequestRef = useRef(0);

    const useRowStyles = makeStyles({
        root: {
            borderBottom: 'unset',
            '& > *': {
                borderBottom: 'unset',
            },
            '& .MuiTableCell-sizeSmall:last-child': {
                paddingRight: '24px',
            },

            '& .MuiTableCell-root:first-child': {
                borderTopLeftRadius: '10px',
                borderBottomLeftRadius: '10px',
            },

            '& .MuiTableCell-root:last-child': {
                borderTopRightRadius: '10px',
                borderBottomRightRadius: '10px',
            },


        },
        oddRow: {
            backgroundColor: `${unoTheme.secondaryTuplaTable} !important`,
            '& .MuiTableRow-root.maybeOdd': {
                background: `${unoTheme.secondaryTuplaTable}`,
            },
        },
        noRadiusBottom: {
            '& .MuiTableCell-root:first-child': {
                borderTopLeftRadius: '10px !important',
                borderBottomLeftRadius: '0px !important',
                backgroundColor: `${unoTheme.secondaryTuplaTable} !important`,
            },
            '& .MuiTableCell-root:last-child': {
                borderTopRightRadius: '10px !important',
                borderBottomRightRadius: '0px !important',
                backgroundColor: `${unoTheme.secondaryTuplaTable} !important`,
            },
        },
        green: {
            color: unoTheme.greenMoney,
        },
        red: {
            color: unoTheme.errorColor,
        },
        blue: {
            color: "blue",
        },
        ok: {
            color: unoTheme.greenMoney,
            cursor: 'pointer',

            fontSize: '1.2em',

        },
        pendent: {
            color: unoTheme.warningColor,
            cursor: 'pointer',
            fontSize: '1.2em',

        },

        disponibilizationWithTip: {
            cursor: 'pointer',
            fontWeight: 'bold',
        },

        hiddenIcon: {
            visibility: 'hidden'
        },
        arrowTableIcon: {
            background: unoTheme.mainColor,
            color: 'white',
            borderRadius: '4px',
            height: '22px',
            width: '22px',

            '&:hover': {
                color: 'white',
                background: unoTheme.hoverMainButtonColor
            }
        },
        noPaddingCell: {
            padding: '0px !important',
            height: '1px',
        },
        ramification1: {
            display: 'flex',
            height: '100% !important',
            width: '100% !important',
            alignItems: 'center',

            '& .rLeft': {
                height: '100%',
                width: '50%',
                marginLeft: '7px',
                '& .lTop': {
                    height: '50%',
                    width: '100%',
                    borderRight: 'solid 1px #dddee0',
                },

                '& .lBottom': {
                    height: '50%',
                    width: '100%',
                    borderRight: 'solid 1px #dddee0',
                },
            },

            '& .rRight': {
                height: '100%',
                width: '50%',
                '& .tTop': {
                    height: '50%',
                    width: '100%',
                    borderBottom: `solid 1px #dddee0`,
                },

                '& .tBottom': {
                    height: '50%',
                    width: '100%',
                },
            },

            '& .littleBall': {
                height: '7px',
                width: '8px',
                borderRadius: '50%',
                background: unoTheme.mainColor,
                marginTop: '-1.5px',
            }

        },
        tableFixed: {
            tableLayout: 'fixed',
        },
        borderOnOpen: {
            '& > *': {
                borderBottom: 'unset',
            },
        },
        // lastSubAssetBorderBottom: {
        //     '& > *': {
        //         borderBottom: 'unset !important',
        //     },
        // }

        ellipsis: {
            whiteSpace: "nowrap", /* Impede a quebra de linha */
            overflow: "hidden", /* Garante que o texto extra seja ocultado */
            textOverflow: "ellipsis",
        },

        almostOutOfCompliance: {
            color: unoTheme.almostOutOfComplianceColor + ' !important',
            fontWeight: '600',
            borderRadius: '4px',
            padding: '2px 0px',
            display: 'inline-block',
            minWidth: '50px',
        },
        outOfCompliance: {
            color: unoTheme.outOfComplianceColor + ' !important',
            fontWeight: '600',
            borderRadius: '4px',
            padding: '2px 0px',
            display: 'inline-block',
            minWidth: '50px',
        },

    });

    function getColGroup() {
        return (
            <colgroup>
                <col width="5%" />
                <col width="25%" />
                <col width="15%" />
                <col width="12%" />
                <col width="7%" />
                <col width="7%" />
                <col width="9%" />
                <col width="12%" />
                <col width="8%" />
            </colgroup>
        )
    }

    function Row(props) {
        const { row, index } = props;
        const [open, setOpen] = React.useState(false);
        const classes = useRowStyles();

        const isTitle = row.title_id != null;

        let disponibilization = null;
        if (row.local_liquidity) {
            disponibilization = disponibilizationDicionary(row.local_liquidity);
        } else if (row['dados_cadastrais']) {
            disponibilization = disponibilizationDicionary(row['dados_cadastrais'].disponibilization);
        }

        if (row.isNegativeAsset && row.quotas_anbima?.length) {
            row.realNegativeBalance = applyMaskAmount(
                row.quota_amount_now * row.quotas_anbima[row.quotas_anbima.length - 1].valor_cota,
                true);
        }

        const complianceOutStatus = getAssetOutComplianceStatus(row);
        const complianceAlmostOutStatus = getAssetAlmostOutComplianceStatus(row);

        return (
            <React.Fragment>
                <TableRow key={'asset-' + index}
                    className={[
                        index % 2 != 1 ? classes.oddRow : "",
                        classes.root,
                        open && index % 2 != 1 ? classes.noRadiusBottom : ""
                    ].join(' ')}>
                    <TableCell align="center">

                        <IconButton aria-label="expand row" size="small"
                            className={[
                                (!row.subAssets || (row.subAssets && row.subAssets.length) == 0)
                                    && (!row.subAssetsTitles || (row.subAssetsTitles && row.subAssetsTitles.length) == 0) ?
                                    classes.hiddenIcon : "", classes.arrowTableIcon].join(' ')}
                            onClick={() => setOpen(!open)}>
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>

                    </TableCell>
                    <TableCell className={classes.ellipsis}>
                        {!isTitle ? row.fund_name : getTitleCod(row)}
                    </TableCell>
                    <TableCell align="right" className={classes.green}>

                        <span style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "end",
                            gap: "4px"
                        }}>

                            {
                                row.isNegativeAsset ?
                                    <LightTooltip title={row.realNegativeBalance} placement="bottom" arrow>
                                        <InfoIcon style={{ color: "blueviolet", fontSize: "15px" }} />
                                    </LightTooltip> : null
                            }
                            {
                                row.balance_now != undefined ?
                                    applyMaskAmount(row.balance_now, true)
                                    : 'Não informado'
                            }
                        </span>
                    </TableCell>

                    {/* Participação */}
                    <TableCell align="right">

                        <LightTooltip
                            interactive={complianceOutStatus?.length}
                            title={
                                complianceOutStatus?.length || complianceAlmostOutStatus?.length
                                    ?
                                    (complianceOutStatus?.length ? complianceOutStatus.join(', ') : complianceAlmostOutStatus.join(', ')) : ""
                            }
                            placement="right" arrow>
                            <span
                                className={
                                    complianceOutStatus?.length || complianceAlmostOutStatus?.length ?
                                        (complianceOutStatus?.length ? classes.outOfCompliance : classes.almostOutOfCompliance) : ''
                                }
                                style={{
                                    cursor: complianceOutStatus?.length || complianceAlmostOutStatus?.length ? 'pointer' : 'default',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                }}
                            >
                                {
                                    complianceOutStatus?.length || complianceAlmostOutStatus?.length ? (
                                        <WarningIcon
                                            style={{
                                                fontSize: '16px',
                                                color: complianceOutStatus?.length ? unoTheme.outOfComplianceColor : unoTheme.almostOutOfComplianceColor,
                                            }}
                                        />
                                    )
                                        : null
                                }

                                {row.participation}%

                            </span>
                        </LightTooltip>

                    </TableCell>

                    {/* Disponibilidade */}
                    <TableCell align="center">
                        {disponibilization ?
                            (
                                disponibilization.tip ?
                                    <LightTooltip title={disponibilization.tip} placement="bottom" arrow>
                                        <span className={classes.disponibilizationWithTip}>{disponibilization.label}</span>
                                    </LightTooltip>

                                    :

                                    disponibilization.label
                            )

                            : '-'}

                    </TableCell>

                    {/* Carência */}
                    <TableCell align="center">
                        <span style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            gap: "4px"
                        }}>

                            {isTitle || !row.lack_liquidity_date ?
                                "-"
                                :
                                <LightTooltip title={moment.utc(row.lack_liquidity_date).format('DD/MM/YYYY')} placement="bottom" arrow>
                                    <InfoIcon style={{ color: "darkorange", fontSize: "17px" }} />
                                </LightTooltip>}
                        </span>


                    </TableCell>

                    {/* Enquadramento */}
                    <TableCell align="center">
                        <span style={row.device_abbreviation?.includes('-') ? { fontSize: "0.8em" } : {}}>{row.device_abbreviation ? row.device_abbreviation : '-'}</span>
                    </TableCell>



                    {/* Retorno mensal */}

                    {
                        row.fund_name === GENERIC_ASSETS ? //exibindo "-" no caso de imóvel
                            <TableCell align={"right"}>
                                -
                            </TableCell>
                            :
                            <TableCell align={"right"}>
                                {
                                    rentMonthMode == 'percent'
                                        ?
                                        applyMaskAmount(row.rentPercentInMonth, null, true) + '%'
                                        :
                                        applyMaskAmount(row.rentMoneyInMonth, true)
                                }
                            </TableCell>
                    }

                    <TableCell
                        align={"center"}>
                        {row["dados_cadastrais"]?.administration_tax != null ?
                            applyMaskAmount(row["dados_cadastrais"].administration_tax) + "%" : "-"}

                    </TableCell>

                </TableRow>
                <TableRow
                    className={[classes.innerTableRow, index % 2 == 0 ? classes.oddRow : "", open ? "" : classes.borderOnOpen].join(' ')}>
                    <TableCell style={{ padding: 0 }} colSpan={9}>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            <Box>
                                <Table size="small"
                                    className={classes.tableFixed}>

                                    {getColGroup()}

                                    {/* Collpase de fundos */}
                                    {

                                        row
                                            && row.subAssets ?
                                            <TableBody>
                                                {row.subAssets.map((subAsset, index) => (
                                                    <TableRow key={'sub-asset-' + index}
                                                        className={[classes.root].join(' ')}>
                                                        <TableCell align="center"
                                                            className={classes.noPaddingCell}>

                                                            <div className={classes.ramification1}>

                                                                <div className={'rLeft'}>
                                                                    <div className={'lTop'}>

                                                                    </div>
                                                                    {
                                                                        index == row.subAssets.length - 1 ?
                                                                            null
                                                                            :
                                                                            <div className={'lBottom'}>

                                                                            </div>
                                                                    }
                                                                </div>
                                                                <div className={'rRight'}>
                                                                    <div className={'tTop'}>

                                                                    </div>

                                                                    <div className={'tBottom'}>

                                                                    </div>

                                                                </div>
                                                                <div className={'littleBall'}></div>
                                                            </div>

                                                            {/* <IconButton aria-label="expand row" size="small"
                                                                className={[classes.arrowTableIcon].join(' ')}>
                                                                <KeyboardArrowUpIcon />
                                                            </IconButton> */}

                                                        </TableCell>
                                                        <TableCell>
                                                            <span>CC: {applyMaskAccount(subAsset.number_account)} {subAsset.agency ? "/ Ag: " + subAsset.agency : ""}</span>
                                                        </TableCell>
                                                        <TableCell align="right" className={classes.green}>
                                                            {
                                                                subAsset.balance_now != 'Não informado' ?
                                                                    applyMaskAmount(subAsset.balance_now, true)
                                                                    : 'Não informado'
                                                            }
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            {subAsset.participation}%
                                                        </TableCell>
                                                        {/* Disponibilidade */}
                                                        <TableCell align="center">{'-'}</TableCell>
                                                        {/* Carência */}
                                                        <TableCell align="center">{'-'}</TableCell>
                                                        {/* Enquadramento */}
                                                        <TableCell align="center">{'-'}</TableCell>
                                                        {/* Retorno mensal */}
                                                        <TableCell align="right">{'-'}</TableCell>

                                                        <TableCell align="center"
                                                            className={classes.pendent}>
                                                            {/* <ReportProblemIcon /> */}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody> : null
                                    }

                                    {

                                        row
                                            && row.subAssetsTitles ?
                                            <TableBody>
                                                {row.subAssetsTitles.map((subAsset, index) => (
                                                    <TableRow key={'sub-asset-title' + index}
                                                        className={[classes.root].join(' ')}>
                                                        <TableCell align="center"
                                                            className={classes.noPaddingCell}>

                                                            <div className={classes.ramification1}>

                                                                <div className={'rLeft'}>
                                                                    <div className={'lTop'}>

                                                                    </div>
                                                                    {
                                                                        index == row.subAssetsTitles.length - 1 ?
                                                                            null
                                                                            :
                                                                            <div className={'lBottom'}>

                                                                            </div>
                                                                    }
                                                                </div>
                                                                <div className={'rRight'}>
                                                                    <div className={'tTop'}>

                                                                    </div>

                                                                    <div className={'tBottom'}>

                                                                    </div>

                                                                </div>
                                                                <div className={'littleBall'}></div>
                                                            </div>

                                                        </TableCell>
                                                        <TableCell>
                                                            <span><span style={{ color: 'blue' }}>{getTitleCod(subAsset)}</span> / CC: {applyMaskAccount(subAsset.number_account)} {subAsset.agency ? "/ Ag: " + subAsset.agency : ""}</span>
                                                        </TableCell>
                                                        <TableCell align="right" className={classes.green}>
                                                            {
                                                                subAsset.balance_now != 'Não informado' ?
                                                                    applyMaskAmount(subAsset.balance_now, true)
                                                                    : 'Não informado'
                                                            }
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            {subAsset.participation}%
                                                        </TableCell>
                                                        {/* Disponibilidade */}
                                                        <TableCell align="center">{'-'}</TableCell>
                                                        {/* Carência */}
                                                        <TableCell align="center">{'-'}</TableCell>
                                                        {/* Enquadramento */}
                                                        <TableCell align="center">{subAsset.device_abbreviation}</TableCell>
                                                        {/* Retorno mensal */}
                                                        <TableCell align="right">{'-'}</TableCell>

                                                        <TableCell align="center"
                                                            className={classes.pendent}>
                                                            {/* <ReportProblemIcon /> */}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody> : null
                                    }

                                    {/* {
                                        row.transactions && row.transactions.length > 0 ?
                                            <TableFooter>
                                                <TableRow key={'footer-t-transactions'}>
                                                    <TableCell align="left">Total:</TableCell>
                                                    <TableCell align="center"></TableCell>
                                                    <TableCell align="right">{applyMaskAmount(row.resultAmount, true)}</TableCell>
                                                    <TableCell align="center"></TableCell>
                                                    <TableCell align="center"></TableCell>
                                                    <TableCell align="center"></TableCell>
                                                    <TableCell align="center"></TableCell>
                                                </TableRow>
                                            </TableFooter> : null
                                    } */}
                                </Table>
                            </Box>
                        </Collapse>
                    </TableCell>
                </TableRow>
            </React.Fragment>
        );
    }

    const loadComplianceData = useCallback(async (clientId, assets, month, year, promanagementCode, portfolioResolutionName) => {

        const requestId = ++complianceRequestRef.current;

        try {
            const responseProccessArticles = await LegislationArticleAPI.proccessAndCheckNonComplienceArticles(
                clientId,
                assets,
                month,
                year,
                promanagementCode
            );

            console.log("Compliance Data: ", responseProccessArticles);

            if (responseProccessArticles.success) {

                const allAssetsOuts13 = [];
                const allAssetsOuts14 = [];
                const allAssetsOuts18 = [];
                const allAssetsOuts19 = [];
                const allAssetsOutsTargets = [];
                const allAssetsOutsLimitResolution = [];
                const mapAlmostOutsTargets = {};
                if (responseProccessArticles.outsArt13.length) {
                    responseProccessArticles.outsArt13.forEach(element => {
                        allAssetsOuts13.push.apply(allAssetsOuts13, element.assetsOutArt13)
                    });
                }
                if (responseProccessArticles.outsArt14.length) {
                    responseProccessArticles.outsArt14.forEach(element => {
                        allAssetsOuts14.push.apply(allAssetsOuts14, element.assetsOutArt14)
                    });
                }
                if (responseProccessArticles.outsArt18.length) {
                    responseProccessArticles.outsArt18.forEach(element => {
                        allAssetsOuts18.push.apply(allAssetsOuts18, element.assetsOutArt18)
                    });
                }
                if (responseProccessArticles.outsArt19.length) {
                    responseProccessArticles.outsArt19.forEach(element => {
                        allAssetsOuts19.push.apply(allAssetsOuts19, element.assetsOutArt19)
                    });
                }
                if (responseProccessArticles.outsLimitResolution.length) {
                    responseProccessArticles.outsLimitResolution.forEach(element => {
                        allAssetsOutsLimitResolution.push.apply(allAssetsOutsLimitResolution, element.assets)
                    });
                }
                if (responseProccessArticles.outsTargets.length) {
                    responseProccessArticles.outsTargets.forEach(element => {
                        allAssetsOutsTargets.push.apply(allAssetsOutsTargets, element.assets)
                    });
                }
                if (responseProccessArticles.almostOutsTargets.length) {
                    responseProccessArticles.almostOutsTargets.forEach(element => {
                        mapAlmostOutsTargets[element.id] = element
                    });
                }

                //Resolução 5.272: além dos arrays por artigo, o backend devolve o catálogo de
                //regras e os desenquadramentos já atrelados à regra que os originou.
                //Vai no mesmo objeto de propósito: a função Row é declarada dentro do componente,
                //então cada setState extra remontaria as linhas e fecharia as que estão expandidas
                const violations5272 = responseProccessArticles.outsRules5272 || [];
                const rules5272 = responseProccessArticles.rules5272
                    && responseProccessArticles.rules5272.length ?
                    {
                        rules: responseProccessArticles.rules5272,
                        byCode: responseProccessArticles.outsRules5272ByCode,
                        violations: violations5272,
                        index: buildRulesComplianceIndex(violations5272),
                        resolutionName: portfolioResolutionName,
                        //Gestoras sem volume gerido no arquivo: aparecem como aviso, porque sem
                        //base a regra não foi apurada e a carteira não pode ser dada por enquadrada
                        notEvaluated: responseProccessArticles.outsRules5272NotEvaluated || [],
                        //Quadro das regras por estado. Derivado uma vez aqui para que o botão do
                        //header e o painel contem a mesma coisa
                        overview: buildRulesOverview(responseProccessArticles.outsRules5272ByCode),
                    } : null;

                const data = {
                    allAssetsOuts13,
                    allAssetsOuts14,
                    allAssetsOuts18,
                    allAssetsOuts19,
                    allAssetsOutsTargets,
                    allAssetsOutsLimitResolution,
                    mapAlmostOutsTargets,
                    rules5272,
                };

                //Resposta obsoleta: o contexto já mudou enquanto esta requisição voava
                if (requestId !== complianceRequestRef.current) {
                    return null;
                }

                setComplianceData(data);

                return data;
            }
        } catch (error) {
            console.error('Erro ao carregar dados de compliance:', error);
        }
        return null;
    }, []);

    const getAssetOutComplianceStatus = (asset) => {
        if (!complianceData) return null;
        //Na 5.272 o aviso cita a regra violada, o percentual apurado e o limite;
        //nas demais resoluções segue citando o artigo
        if (complianceData.rules5272) {
            return checkRulesComplianceOutStatus(asset, complianceData.rules5272);
        }
        return checkComplianceOutStatus(asset, complianceData);
    };
    const getAssetAlmostOutComplianceStatus = (asset) => {
        if (!complianceData) return null;
        return checkComplianceAlmostOutStatus(asset, complianceData);
    };

    //Leva o resultado do enquadramento por regras para o header (PortfolioScreen) e fecha o
    //painel lateral, que não pode seguir aberto com os desenquadramentos do contexto anterior.
    //onComplianceLoaded fica fora das deps de propósito: o pai passa o setter de useState
    useEffect(() => {

        if (onComplianceLoaded) {
            onComplianceLoaded(complianceData && complianceData.rules5272 ?
                {
                    byCode: complianceData.rules5272.byCode,
                    resolutionName: complianceData.rules5272.resolutionName,
                    totalViolations: complianceData.rules5272.violations.length,
                    isOut: complianceData.rules5272.violations.length > 0,
                    notEvaluated: complianceData.rules5272.notEvaluated,
                    notEvaluatedBalance: (complianceData.rules5272.notEvaluated || [])
                        .reduce((total, item) => total + (parseFloat(item.balance) || 0), 0),
                    //O header precisa saber quantas regras estão contempladas para dizê-lo no
                    //tooltip, e o painel recebe o mesmo quadro pelo byCode
                    overview: complianceData.rules5272.overview,
                }
                : null);
        }

        dispatch(allActions.rightContentActions.setRightContent(null));

    }, [complianceData]);

    //Ao sair da aba o header não pode continuar anunciando o status da carteira
    useEffect(() => {
        return () => {
            if (onComplianceLoaded) {
                onComplianceLoaded(null);
            }
            dispatch(allActions.rightContentActions.setRightContent(null));
        }
    }, []);

    const loadInfosAssets = useCallback(async (clientId, month, year, accountRegimeId, doQuotas) => {

        console.log("PASSANDO LOAD INFOS ASSETS");

        //O compliance do contexto anterior não vale mais. Zerar aqui cobre também os caminhos que
        //não chegam a carregá-lo: erro na requisição, usuário sem a role, carteira sem ativos
        setComplianceData(null);

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: true,
            cod: codsInnerLoad.assetsScreen,
            loadMessage: 'Carregando ativos...',
        }));

        try {
            let responseInfosAssets = await getAssetInfos(clientId, month, year, accountRegimeId, doQuotas);
            let lastDiaryMonth = await loadClientDiaryByRange(clientId, month, year, 1);
            const responseSegregation = clientOn.client.is_cotization_segregation ?
                await loadClientRentsBySegregation(clientId, month, year, 1)
                : null;
            console.log("responseSegregation: ", responseSegregation);
            setMapRentsBySegregation(responseSegregation ? responseSegregation.mapRentsBySegregation : null);


            console.log("### INFO ASSETS: ", responseInfosAssets);

            if (responseInfosAssets.success) {
                setAssetsFormatted(responseInfosAssets.assetsFormatted);
                setResolutionName(responseInfosAssets.resolutionName);
                setTotalResultAmount(responseInfosAssets.totalResultAmount);
                setTotalRentMoneyInMonth(responseInfosAssets.totalRentMoneyInMonth);

                if (accountRegimeId) {

                    console.log("accountRegimeId: ", accountRegimeId);

                    //Regra para caso de existir apenas 1 asset
                    // if (responseInfosAssets.assetsFormatted.length === 1) {
                    //     setTotalRentPercentInMonth(responseInfosAssets.assetsFormatted[0].rentPercentInMonth);
                    // } else {
                    //     setTotalRentPercentInMonth(responseSegregation.mapRentsBySegregation[accountRegimeId]);
                    // }
                    console.log("1: ", responseSegregation);
                    console.log("2: ", responseSegregation.mapRentsBySegregation);
                    setTotalRentPercentInMonth(responseSegregation.mapRentsBySegregation[accountRegimeId]);
                } else {
                    setTotalRentPercentInMonth(lastDiaryMonth.arrayRents && lastDiaryMonth.arrayRents.length === 1 ? lastDiaryMonth.arrayRents[0].rent : 0);
                }
                setTotalDisponibilityInAccounts(responseInfosAssets.totalDisponibilityInAccounts);


                const { startDate } = getFirstAndEndDateByMonthAndYear(month, year);
                //Liberando inicialmente funcionalidade apenas para usuários internos da LEMA
                if (
                    //!isLastResolutionDate(startDate) && 
                    clientOn && clientOn.client
                    && checkUserIsRole(currentUser, [roles.superadmin, roles.admin, roles.advisor])) {
                    await loadComplianceData(
                        clientOn.client.id,
                        responseInfosAssets.assetsFormatted,
                        month,
                        year,
                        clientOn.client.promanagement_code,
                        responseInfosAssets.resolutionName
                    );
                }
            } else {
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    message: responseInfosAssets.message,
                }));
            }

            if (responseInfosAssets && responseInfosAssets.assetsFormatted.length == 0) {
                dispatch(allActions.innerLoadActions.setInnerLoad({
                    show: true,
                    emptyMessage: "Não existem ativos na carteira no mês para esse regime de conta",
                    cod: codsInnerLoad.assetsScreen
                }));
            } else {
                dispatch(allActions.innerLoadActions.setInnerLoad({
                    show: false,
                    cod: codsInnerLoad.assetsScreen
                }));
            }

        } catch (error) {
            console.error('Erro ao carregar dados:', error);
            dispatch(allActions.innerLoadActions.setInnerLoad({
                show: false,
                cod: codsInnerLoad.assetsScreen
            }));
        }
    }, [loadComplianceData, clientOn, currentUser]);

    async function doReport() {


        //accountRegimeId é o id do regime (null/0 = consolidado), não um índice de array
        const regimeLabel = getRegimeLabel(accountRegimeId);

        console.log('regimeLabel: ', regimeLabel);

        dispatch(allActions.reportLoadActions.setReportLoad({
            show: true,
            reportType: reportTypes.portfolio.cod,
            periodReport: 'mensal',
            regimeLabel: regimeLabel,
            accountRegimeId: accountRegimeId, //Adicionando parametro para gerar relatório com segregacao
            message: 'Gerando o relatório...'
        }))

    }

    function doExcelPortfolio(fileName, month, year, items, resolutionName) {

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: true,
            loadMessage: 'Gerando planilha...',
        }));

        console.log("items: ", items);

        const wb = XLSX.utils.book_new();
        wb.Props = {
            Title: "Carteira",
            Author: "UNO",
        }

        const sheetName = "Carteira " + getMonthName(month) + "-" + year;
        wb.SheetNames.push(sheetName);

        const ws_data = [];

        ws_data.push(['ATIVO', 'CNPJ', 'SALDO', 'PARTICIPAÇÃO', 'DISPONIBILIZAÇÃO', resolutionName, 'RET.MENSAL(%)', 'RET.MENSAL(R$)', 'APRS PREENCHIDAS'])

        items.forEach(element => {
            ws_data.push([
                element.fund_name,
                element.cnpj,
                applyMaskAmount(element.balance_now),
                element.participation,
                element['dados_cadastrais'] ? disponibilizationDicionary(element['dados_cadastrais'].disponibilization).label : '-',
                element.device_abbreviation,
                applyMaskAmount(element.rentPercentInMonth, null, true) + '%',
                applyMaskAmount(element.rentMoneyInMonth, true),
                element.aprs ? 'SIM' : 'NÃO'
            ])
        });

        const ws = XLSX.utils.aoa_to_sheet(ws_data);

        wb.Sheets[sheetName] = ws;
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' })

        downloadBlob(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName + '.xlsx');

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: false,
        }));

    }

    const {
        accountRegimeId,
        flagDoExcelPortfolio,
        resetFlag,
    } = props

    useEffect(() => {


        //Caso em que alterou-se o cliente
        if (clientOn && clientOn.client
            && (!clientOnScreen || clientOn.client.id != clientOnScreen.id)) {

            dispatch(allActions.innerLoadActions.setInnerLoad({
                show: true,
                cod: codsInnerLoad.assetsScreen,
                loadMessage: 'Carregando ativos...',
            }));

            setAssetsFormatted([]);
            setComplianceData(null);
            setTotalResultAmount(0);
            setTotalRentMoneyInMonth(0);
            setTotalRentPercentInMonth(0);

            //atualizando account regime para testar numa possível mudança
            clientOn.client.accountRegimeId = accountRegimeId;
            setClientOnScreen(_.cloneDeep(clientOn.client));
            if (clientOn.client.selectedPortfolioMonth && clientOn.client.selectedPortfolioYear) {

                loadInfosAssets(clientOn.client.id,
                    clientOn.client.selectedPortfolioMonth,
                    clientOn.client.selectedPortfolioYear,
                    accountRegimeId,
                    false);

            } else {
                dispatch(allActions.innerLoadActions.setInnerLoad({
                    show: true,
                    emptyMessage: "Este cliente ainda não possui nenhum mês com ativos fechados",
                    cod: codsInnerLoad.assetsScreen
                }));
            }

            //Caso em que alterou-se o mês ou o ano no controller no dashboard
        } else if (clientOn && clientOn.client && clientOnScreen
            && clientOn.client.id == clientOnScreen.id
            && clientOn.client.selectedPortfolioMonth && clientOn.client.selectedPortfolioYear
            && clientOn.client.portfolio_closed != clientOnScreen.portfolio_closed) {

            dispatch(allActions.innerLoadActions.setInnerLoad({
                show: true,
                loadMessage: 'Carregando ativos...',
                cod: codsInnerLoad.assetsScreen
            }));

            setAssetsFormatted([]);
            setComplianceData(null);
            setTotalResultAmount(0);
            setTotalRentMoneyInMonth(0);
            setTotalRentPercentInMonth(0);

            clientOn.client.accountRegimeId = accountRegimeId;
            setClientOnScreen(_.cloneDeep(clientOn.client));
            //loadData(clientOn.client.id, clientOn.client.selectedMonth, clientOn.client.selectedYear);
            let splittedClosedMonth = "";
            if (clientOn.client.portfolio_closed) {
                splittedClosedMonth = clientOn.client.portfolio_closed.split('/');
                loadInfosAssets(clientOn.client.id,
                    splittedClosedMonth[0],
                    splittedClosedMonth[1],
                    accountRegimeId,
                    false);
            } else {
                dispatch(allActions.innerLoadActions.setInnerLoad({
                    show: true,
                    emptyMessage: "Este cliente ainda não possui nenhum mês com ativos fechados",
                    cod: codsInnerLoad.assetsScreen
                }));
            }

            //Caso em que alterou-se o mês ou o ano
        } else if (clientOn && clientOn.client && clientOnScreen
            && clientOn.client.id == clientOnScreen.id
            && clientOn.client.selectedPortfolioMonth && clientOn.client.selectedPortfolioYear
            && (
                clientOn.client.selectedPortfolioMonth != clientOnScreen.selectedPortfolioMonth
                ||
                clientOn.client.selectedPortfolioYear != clientOnScreen.selectedPortfolioYear
                ||
                accountRegimeId != clientOnScreen.accountRegimeId
            )
        ) {

            dispatch(allActions.innerLoadActions.setInnerLoad({
                show: true,
                loadMessage: 'Carregando ativos...',
                cod: codsInnerLoad.assetsScreen
            }));

            setAssetsFormatted([]);
            setComplianceData(null);
            setTotalResultAmount(0);
            setTotalRentMoneyInMonth(0);
            setTotalRentPercentInMonth(0);

            clientOn.client.accountRegimeId = accountRegimeId;
            setClientOnScreen(_.cloneDeep(clientOn.client));

            loadInfosAssets(clientOn.client.id,
                clientOn.client.selectedPortfolioMonth,
                clientOn.client.selectedPortfolioYear,
                accountRegimeId,
                false);

        }

        if (flagDoExcelPortfolio) {

            console.log("CHAMANDEO DO EXCEL PORTFOLIO:");
            if (clientOn.client.selectedPortfolioMonth &&
                clientOn.client.selectedPortfolioYear &&
                assetsFormatted && assetsFormatted.length) {

                doExcelPortfolio(
                    clientOn.client.label_name + "_CARTEIRA_" + getMonthName(clientOn.client.selectedPortfolioMonth) + "_" + clientOn.client.selectedPortfolioYear,
                    clientOn.client.selectedPortfolioMonth,
                    clientOn.client.selectedPortfolioYear,
                    assetsFormatted,
                    resolutionName
                )
            }

            resetFlag();
        }

    }, [clientOn,
        accountRegimeId,
        flagDoExcelPortfolio])

    return (
        <div className={classes.root}>

            <div className={classes.mainRoot}>
                <div class={'defaultScrollWithHeaderContent'}>

                    {
                        assetsFormatted && assetsFormatted.length > 0 ?

                            <TableContainer component={Paper} className={classes.tableContainer} elevation={0}>
                                <Table stickyHeader className={classes.table} size="small" >

                                    {getColGroup()}
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center"></TableCell>
                                            <TableCell align="left">Ativo</TableCell>
                                            <TableCell align="right">Saldo</TableCell>
                                            <TableCell align="right">
                                                <LightTooltip title={"Participação na carteira"} placement="top" arrow>
                                                    <span>Particip.</span>
                                                </LightTooltip>

                                            </TableCell>
                                            <TableCell align="center">
                                                <LightTooltip title={"Disponibilidade de resgate"} placement="top" arrow>
                                                    <span>Disp.</span>
                                                </LightTooltip>
                                            </TableCell>
                                            <TableCell align="center">
                                                Carên.
                                            </TableCell>
                                            <TableCell align="center">
                                                {resolutionName ? resolutionName : '-'}
                                            </TableCell>
                                            <TableCell align="right" className={classes.clickableHead} onClick={() => rentMonthMode == 'value' ? setRentMonthMode('percent') : setRentMonthMode('value')}>
                                                {`Ret. ${rentMonthMode == 'value' ? '(R$)' : '(%)'}`}
                                            </TableCell>
                                            {/* <TableCell align="center">APRs</TableCell> */}
                                            <TableCell align="center">TX ADM</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {assetsFormatted.map((row, index) => (
                                            <Row key={'asset-formatted-portfolio-' + index} row={row} index={index} />
                                        ))}
                                    </TableBody>

                                    {
                                        assetsFormatted && assetsFormatted.length > 0 ?
                                            <TableFooter className={classes.myTableFooter}>
                                                <TableRow className='totalLineInvestiments' key={'footer-t-assets-collect-investiments'}>
                                                    <TableCell align="left"></TableCell>
                                                    <TableCell align="left">TOTAL INVESTIMENTOS</TableCell>
                                                    <TableCell align="right"><span className={'spanTotal'}>{totalResultAmount ? applyMaskAmount(totalResultAmount, true) : "-"}</span></TableCell>
                                                    <TableCell align="right"><span className={'spanTotal'}>100%</span></TableCell>
                                                    <TableCell align="center"></TableCell>
                                                    <TableCell align="center"></TableCell>
                                                    <TableCell align="center"></TableCell>
                                                    <TableCell align="right"><span className={'spanTotal'}>{

                                                        rentMonthMode == 'percent'
                                                            ?
                                                            applyMaskAmount(totalRentPercentInMonth) + '%'
                                                            :
                                                            (totalRentMoneyInMonth ? applyMaskAmount(totalRentMoneyInMonth, true) : "-")


                                                    }</span></TableCell>
                                                    <TableCell align="center"></TableCell>
                                                </TableRow>
                                                <TableRow className='disponibilityLine' key={'footer-t-assets-collect-disponibility'}>
                                                    <TableCell align="left"></TableCell>
                                                    <TableCell align="left">DISPONIBILIDADE</TableCell>
                                                    <TableCell align="right"><span className={'spanTotal'}>{totalDisponibilityInAccounts.now ? applyMaskAmount(totalDisponibilityInAccounts.now, true) : "-"}</span></TableCell>
                                                    <TableCell align="center"></TableCell>
                                                    <TableCell align="center"></TableCell>
                                                    <TableCell align="center"></TableCell>
                                                    <TableCell align="center"></TableCell>
                                                    <TableCell align="center"></TableCell>
                                                    <TableCell align="center"></TableCell>
                                                </TableRow>
                                                <TableRow className='totalLinePL' key={'footer-t-assets-collect-total'}>
                                                    <TableCell align="left"></TableCell>
                                                    <TableCell align="left">TOTAL PATRIMÔNIO</TableCell>
                                                    <TableCell align="right"><span className={'spanTotal'}>{totalResultAmount != null && totalDisponibilityInAccounts.now != null ?
                                                        applyMaskAmount(totalResultAmount + totalDisponibilityInAccounts.now, true) : '-'}</span></TableCell>
                                                    <TableCell align="center"></TableCell>
                                                    <TableCell align="center"></TableCell>
                                                    <TableCell align="center"></TableCell>
                                                    <TableCell align="center"></TableCell>
                                                    <TableCell align="center"></TableCell>
                                                    <TableCell align="center"></TableCell>
                                                </TableRow>
                                            </TableFooter> : null
                                    }

                                    {/* <TableFooter className={classes.myTableFooter}>
                                        <TableRow key={'footer-t-assets'}>
                                            <TableCell align="center"></TableCell>
                                            <TableCell align="left">Total</TableCell>
                                            <TableCell align="right">
                                                <span className={'spanTotal'}>{applyMaskAmount(totalResultAmount, true)}</span>
                                            </TableCell>
                                            <TableCell align="center"></TableCell>
                                            <TableCell align="center"></TableCell>
                                            <TableCell align="center"></TableCell>
                                            <TableCell align="center"></TableCell>
                                        </TableRow>
                                    </TableFooter> */}


                                </Table>
                            </TableContainer>
                            :
                            null
                        // <MyInnerLoad
                        //     size={'small'}
                        //     message={'Carregando ativos...'} />
                    }

                </div>



                {/* <NewAssetModal
                open={openAssetModal}
                handleClose={(update) => handleCloseAssetModal(update)}
                asset={assetSelected} /> */}
            </div>

            {
                clientOn
                    && clientOn.client
                    && clientOn.client.portfolio_closed ?
                    <Zoom
                        in={appearFab}
                        unmountOnExit>

                        {/* <Fab className={classes.fabAdd}
                    onClick={() => doOpenAccountModal()}
                    color="primary" aria-label="add">
                    <AddIcon />
                </Fab> */}
                        <Fab className={classes.fabAdd}
                            onClick={() => doReport()}
                            color="primary" aria-label="add">
                            <PrintIcon />
                        </Fab>
                    </Zoom> : null
            }

        </div>
    );
}


